import { render, staticRenderFns } from "./LikedCard.vue?vue&type=template&id=50fb3794&"
import script from "./LikedCard.vue?vue&type=script&lang=js&"
export * from "./LikedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports